import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import gamesCategories from 'prismic-translates/games-categories.json'

const t = getTranslationFromJson([gamesCategories])

export default t
